import React from 'react';

import { TextField, TextFieldProps } from 'components/TextField';

export const NameField: React.VFC<TextFieldProps> = ({
  id,
  name,
  autoComplete,
  required,
  ...rest
}) => (
  <TextField
    id={id}
    name={name}
    autoComplete={autoComplete}
    required={!!required}
    // \p{L} is any unicode letter in any language. Require at least one letter per name and a space between names
    pattern="\s*[\p{L}\-']+(\s+[\p{L}\-']+)*\s*"
    {...rest}
  />
);
